<template>
<div class="1Wontainer" style="padding-top: 0rem;">

	<div class="row">
		<div class="col-lg-12">
			<div class="support-index content-box ">
				<!-- add panel-fullscreen for fullscreen -->
				<div class="support-ticket-content-w folded-info">

					<div class="support-ticket-content ">

						<div class="ticket-thread">
<!-- action bar start -->
<div class="navbar-nav ml-auto" style="float:right; display: inline;">
	<a href="#" class="list-group-item pop" style="border:none;font-size: 16px; display:inline; "><i class="tt icon-feather-share"></i> Share</a>
		<a href="#" class="list-group-item pop" style="border:none;font-size: 16px; display:inline;"><i class="tt icon-feather-trash"></i> Delete</a>
		<a href="#" class="list-group-item pop" style="border:none;font-size: 16px; display:inline;"><i class="tt icon-feather-help-circle"></i> Help</a>
<!--
	<li class="1	nav-item" id="__BVID__26"><a aria-haspopup="true" aria-expanded="false" target="_self" href="#" class="nav-link"><i class="icon-feather-link" style="color: rgb(123, 31, 162);"></i> Share</a>
	<a aria-haspopup="true" aria-expanded="false" target="_self" href="#" class="nav-link"><i class="icon-feather-link" style="color: rgb(123, 31, 162);"></i> Delete</a></li>
-->
</div>
<!-- action bar end -->

							<div class="element-box " style="-webkit-box-shadow: none; box-shadow: none;">
							
								<h1><a @click.prevent="editScenarioName" class="pop" style="padding-left: 8px;padding-right: 8px;cursor: pointer; "><i class="icon-feather-edit" style="color:#6f42c1;font-size: 1.25rem;"></i><span style="color: #000;"> {{scenarioName}}</span> </a>  
								<!-- <small class="text-muted">for model B</small> --> </h1>
<!-- balance -->

							<div class="row">
								<hr style="border: none;">
								<div class="col-lg-12">
									<h5>Result</h5>
									<div id="balanceTable" class="table"></div>
								
								</div>
							</div>

								<ve-histogram :colors="chartFcolors" :legend="chartFlegend" :settings="chartFSettings" :data="chartDataF" :extend="chartExtendF"></ve-histogram>
							</div>
							<!-- chart start -->
							<!-- chart end -->
							<!-- balance -->

							

							<hr />
							<div class="row">
								<hr style="border: none;">
								<div class="col-lg-12">
									<h5><a @click.prevent="addRow('expenseTable')" class="pop" style="cursor:pointer;"><i class="icon-feather-plus-circle btncon" style="color: #6f42c1;"></i><span style="color: #000;"> Expenses</span></a></h5>
									<div id="expensesTable" class="table"></div>
								</div>
							</div>
							<hr />
							<div class="row">
								<hr style="border: none;">
								<div class="col-lg-12">
									<h5><a @click.prevent="addRow('incomeTable')" class="pop" style="cursor:pointer;"><i class="icon-feather-plus-circle btncon"  style="color: #6f42c1;"></i> <span style="color: #000;"> Income</span></a></h5>
									<div id="incomeTable" class="table"></div>
								</div>
							</div>



						</div>
					</div>
				</div>
			</div>


		</div>

	</div>
</div>


</template>
<style>
.element-box, .invoice-w, .big-error-w {
    -webkit-animation-name: none;
    animation-name: none;
    /* -webkit-animation-duration: 1s; */
    /* animation-duration: 1s; */
}
</style>

<script>
// 

var menuDelete = function () { 
	window.dispatchEvent(new CustomEvent("hello", {detail: { name: "John" }}));
}

 var groupBy = require('lodash.groupby')
import axios from 'axios'
import * as moment from 'moment';
import store from './../store'
// require styles
import Tabulator from 'tabulator-tables'
import VeHistogram from 'v-charts/lib/histogram.common'
import VeLine from 'v-charts/lib/line.common'
import has from 'lodash.has'
 import notie from 'notie'
 import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css'; // light-border.css  light.css  material.css  translucent.css

require('tabulator-tables/dist/css/tabulator_simple.min.css')
window.tippy = tippy
var printIcon = function(cell, formatterParams, onRendered){ //plain text value
		// console.log('printIcon', cell._cell.row.data.name,cell)
    return '<i class="tt icon-feather-more-horizontal" data-parent="' + cell._cell.row.data.name + '" style="color:#2347cc;"></i>';
};
var printIconHidden = function(cell, formatterParams, onRendered){ //plain text value
// return `<b-button v-b-popover.hover="'I am popover content!'" title="Popover Title">Hover Me</b-button>`
    return '<i class="icon-feather-minus-circle" style="color:white;"></i>';
};

export default {
	name: 'Forecast',
	components: {
		VeHistogram
  },
  filters: {

	},
	watch: {
    //update table if data changes
		incomeData: {
      handler: function (newData) {
				this.refresh()
      },
      deep: true
		},
		expenseData: {
      handler: function (newData) {
				this.refresh()
      },
      deep: true
    },
		
		// balanceData: {
    //  handler: function (newData) {
		//		this.refresh()
    //  },
    //  deep: true
		// }
		
  },
  data () {
		this.chartExtendF = {
			legend: {
				docked: 'bottom',
				toggleable: false
			},
		  series (item) {
				// console.log(item)
				item[0].data = item[0].data.map((v, index) => ({
					value: v,
					itemStyle: { color: '#64CA96' }
				}))
				item[1].data = item[1].data.map((v, index) => ({
					value: v,
					itemStyle: { color: '#E43F4D' }
				}))
				item[2].lineStyle = {color: '#2347cc'}
				item[2].showSymbol = false
				item[2].data = item[2].data.map((v, index) => ({
					value: v,
					itemStyle: { color: '#2347cc' },
					symbol: 'circle'
				}))
				return item
			}
		}
    return {
			scenarioName: 'New scenario',
			isMounted: false,
			balanceData: [],
			incomeData: [],
			expenseData: [],
			chartFcolors: 
				['#64CA96','#E43F4D', '#2347cc'],
			
			chartDataF: {
					columns: ['date', 'Income', 'Expense', 'Balance'],
					showLine: ['Saldo de caja'],
          rows: [
            { 'date': '01/01', 'Ingreso': 200}
          ]
				},
				chartFlegend: {
					selector: false,
					y: 'bottom',
					data:[
						{
							name: 'Income',
							icon: 'circle',
							// color: '#eee'
						},
						{
							name: 'Expense',
							icon: 'circle'
						},
						{
							name: 'Balance',
							icon: 'circle'
						}
					]
					/*
					data: [
            {
								name:'Income',
						}],
					selectorLabel: {
							color: 'yellow',
							borderColor: 'green',
							backgroundColor: 'blue'
					},
					emphasis: {
							selectorLabel: {
									backgroundColor: 'red'
							}
					},
					*/
                        // data: seriesInfo.legendData,
                        // backgroundColor: 'rgba(0,100,50,0.2)'
                    },
				chartFSettings: {
					
					metrics: ['Income', 'Expense','Balance'],
					showLine: ['Balance'],
					width: 390,
    			height: 400,
				
    
					
					/* label: {
          	normal: {  rotate: 90,show: true, position: "top", color: 'black'}
        } */
				},
			editMode: false,
		}
			
  },
  methods: {
		editScenarioName() {
			console.log('editScenarioName')
			let that = this
			notie.input({
				value: that.scenarioName,
        text: '<i class="icon-feather-message-circle"></i>  How do you call this scenario ?  <span style="color: #999;">(press enter to submit)</span>',
        cancelCallback: function (value) {
          // notie.alert({ type: 3, text: 'Cancelled'})
        },
        submitCallback: function (value) {
					// value = value.replace(/\s+/g, '')
					//let capt = value.charAt(0).toUpperCase() + value.slice(1)
					that.scenarioName = value
					// that.addRowAfterDialog(table,capt)
        },
        type: 'text',
        //placeholder: 'something',
        // allowed: new RegExp('(^delete$)', '')
      })
		},
    act () {
      console.log('act')
		},
		addRowAfterDialog (table, name) {
			console.log(table,name)
			let newTableDate = []
			if (table === 'incomeTable') {
					// console.log('Deleting expense')
					newTableDate.push({name:name, Jan: '', Feb: '',Mar: '',Apr: '',May: '',Jun: '', Jul: '',Aug: '',Sep: '',Oct: '',Nov: '',Dec: '' })
					const expenseData = JSON.parse(JSON.stringify(this.incomeData))
					for (let item of expenseData) {
							newTableDate.push(item)
					}
					this.incomeData = []
					this.incomeData = newTableDate
					window.incomeTable.replaceData(this.incomeData)
			}
			if (table === 'expenseTable') {
					// console.log('Deleting expense')
					newTableDate.push({name:name, Jan: '', Feb: '',Mar: '',Apr: '',May: '',Jun: '', Jul: '',Aug: '',Sep: '',Oct: '',Nov: '',Dec: '' })
					const expenseData = JSON.parse(JSON.stringify(this.expenseData))
					for (let item of expenseData) {
							newTableDate.push(item)
					}
					this.expenseData = []
					this.expenseData = newTableDate
					window.expenseTable.replaceData(this.expenseData)
			}
		},
		addRow (table) {
			// notie.alert({ type: 1, text: 'Saved'})
			console.log(table)
			let that = this
			let vType = ''
			if (table === 'expenseTable') {
				vType = 'expense'
			} else {
				vType = 'income'
			}
			notie.input({
        text: '<i class="icon-feather-message-circle"></i>  Enter new '+ vType +' name <span style="color: #999;">(press enter to submit)</span>',
        cancelCallback: function (value) {
          // notie.alert({ type: 3, text: 'Cancelled'})
        },
        submitCallback: function (value) {
					// value = value.replace(/\s+/g, '')
					let capt = value.charAt(0).toUpperCase() + value.slice(1)
					that.addRowAfterDialog(table,capt)
        },
        type: 'text',
        //placeholder: 'something',
        // allowed: new RegExp('(^delete$)', '')
      })

		},
		duplicateRow(id, table) {
			console.log('duplicateRow', id, table)
			let newTableDate = []
			if (table === 'expenseTable') {
					// console.log('Deleting expense')
					const expenseData = JSON.parse(JSON.stringify(this.expenseData))
					for (let item of expenseData) {
						// console.log(item.name,id)
						if (item.name === id) {
							newTableDate.push(item)
							let duplicate = JSON.parse(JSON.stringify(item))
							duplicate.name = item.name + '(1)'
							newTableDate.push(duplicate)
						} else {
							newTableDate.push(item)
						}
					}
					this.expenseData = []
					this.expenseData = newTableDate
					window.expenseTable.replaceData(this.expenseData)
					// console.log(this.expenseData)
			}
			if (table === 'incomeTable') {
					// console.log('Deleting expense')
					const expenseData = JSON.parse(JSON.stringify(this.incomeData))
					for (let item of expenseData) {
						// console.log(item.name,id)
						if (item.name === id) {
							newTableDate.push(item)
							let duplicate = JSON.parse(JSON.stringify(item))
							duplicate.name = item.name + '(1)'
							newTableDate.push(duplicate)
						} else {
							newTableDate.push(item)
						}
					}
					this.incomeData = []
					this.incomeData = newTableDate
					window.incomeTable.replaceData(this.incomeData)
					// console.log(this.expenseData)
			}
		},
		populateRow(id, table) {
			console.log('populateRow', id, table)
			let newTableDate = []
			if (table === 'expenseTable') {
					// console.log('Deleting expense')
					const expenseData = JSON.parse(JSON.stringify(this.expenseData))
					for (let item of expenseData) {
						// console.log(item.name,id)
						if (item.name === id) {
							// console.log('Populating item', item)
							let isFound = false
							let populateValue = ''
							for (let pKey in item) {
								let value = item[pKey]
								if (value !== '' && !isFound && value !== id) {
									isFound = true
									populateValue = item[pKey]
								}
								// console.log(pKey,item[pKey], isFound)
								if(isFound) {
									item[pKey] = populateValue
								}
							}
							newTableDate.push(item)
						} else {
							newTableDate.push(item)
						}
					}
					this.expenseData = []
					this.expenseData = newTableDate
					window.expenseTable.replaceData(this.expenseData)
					// console.log(this.expenseData)
			}
			if (table === 'incomeTable') {
					// console.log('Deleting expense')
					const expenseData = JSON.parse(JSON.stringify(this.incomeData))
					for (let item of expenseData) {
						// console.log(item.name,id)
						if (item.name === id) {
							// console.log('Populating item', item)
							let isFound = false
							let populateValue = ''
							for (let pKey in item) {
								let value = item[pKey]
								if (value !== '' && !isFound && value !== id) {
									isFound = true
									populateValue = item[pKey]
								}
								// console.log(pKey,item[pKey], isFound)
								if(isFound) {
									item[pKey] = populateValue
								}
							}
							newTableDate.push(item)
						} else {
							newTableDate.push(item)
						}
					}
					this.incomeData = []
					this.incomeData = newTableDate
					window.incomeTable.replaceData(this.incomeData)
					// console.log(this.expenseData)
			}
		},
		clearRow(id, table) {
			console.log('clearRow', id, table)
			let newTableDate = []
			if (table === 'expenseTable') {
					// console.log('Deleting expense')
					const expenseData = JSON.parse(JSON.stringify(this.expenseData))
					for (let item of expenseData) {
						// console.log(item.name,id)
						if (item.name === id) {
							newTableDate.push({name:id, Jan: '', Feb: '',Mar: '',Apr: '',May: '',Jun: '', Jul: '',Aug: '',Sep: '',Oct: '',Nov: '',Dec: '' })
						} else {
							newTableDate.push(item)
						}
					}
					this.expenseData = []
					this.expenseData = newTableDate
					window.expenseTable.replaceData(this.expenseData)
					// console.log(this.expenseData)
			}
			if (table === 'incomeTable') {
					// console.log('Deleting expense')
					const expenseData = JSON.parse(JSON.stringify(this.incomeData))
					for (let item of expenseData) {
						// console.log(item.name,id)
						if (item.name === id) {
							newTableDate.push({name:id, Jan: '', Feb: '',Mar: '',Apr: '',May: '',Jun: '', Jul: '',Aug: '',Sep: '',Oct: '',Nov: '',Dec: '' })
						} else {
							newTableDate.push(item)
						}
					}
					this.incomeData = []
					this.incomeData = newTableDate
					window.incomeTable.replaceData(this.incomeData)
					// console.log(this.expenseData)
			}
		},
		deleteRow(id, table) {
			// console.log('Deleting', id, table, this)
			//console.log(this.expenseData)
			let newTableDate = []
			if (table === 'expenseTable') {
					// console.log('Deleting expense')
					const expenseData = JSON.parse(JSON.stringify(this.expenseData))
					for (let item of expenseData) {
						// console.log(item.name,id)
						if (item.name !== id) {
							newTableDate.push(item)
						}
					}
					this.expenseData = []
					this.expenseData = newTableDate
					window.expenseTable.replaceData(this.expenseData)
					// console.log(this.expenseData)
			}
			if (table === 'incomeTable') {
					// console.log('Deleting expense')
					const expenseData = JSON.parse(JSON.stringify(this.incomeData))
					for (let item of expenseData) {
						// console.log(item.name,id)
						if (item.name !== id) {
							newTableDate.push(item)
						}
					}
					this.incomeData = []
					this.incomeData = newTableDate
					window.incomeTable.replaceData(this.incomeData)
					// console.log(this.expenseData)
			}
			// this.refresh()

		},
		refresh () {
			console.log('refresh')
			console.log('refresh data', this.balanceData.length, this.expenseData.length, this.incomeData.length)
			// close tippy
			

			// frooze the actual data
			// const balanceData = JSON.parse(JSON.stringify(this.balanceData))
			const incomeData = JSON.parse(JSON.stringify(this.incomeData))
			const expenseData = JSON.parse(JSON.stringify(this.expenseData))
			this.balanceData = []
			this.balanceData = [
					{name:"Balance", Jan: 100000, Feb: 200000,Mar: 200000,Apr: 200000,May: 200000,Jun: 200000, Jul: 200000,Aug: 200000,Sep: 200000,Oct: 200000,Nov: 200000,Dec: 200000 },
					{name:"PL", Jan: 100000, Feb: 200000,Mar: 200000,Apr: 200000,May: 200000,Jun: 200000, Jul: 200000,Aug: 200000,Sep: 200000,Oct: 200000,Nov: 200000,Dec: 200000 }
			]
			// waiting for data to be populated
			// if (balanceData.length < 0) return true
			if (expenseData.length < 0) return true
			if (incomeData.length < 0) return true
			const months = {name:"Bookings", Jan: 100000, Feb: 200000,Mar: 200000,Apr: 200000,May: 200000,Jun: 200000, Jul: 200000,Aug: 200000,Sep: 200000,Oct: 200000,Nov: 200000,Dec: 200000 }
			// get data from tables
			// refresh chart
			// chartDataF { 'date': '01/01', 'Ingreso': 200}
			let newData = []
			let actBalance = 0
			// this.balanceData = []
			for (const [key, value] of Object.entries(months)) {
				// console.log(key)
				if (key === 'name') continue
				// get balance
				// console.log(this.balanceData[0].Jan)
				
				// if (has(balanceData[0],key)) {
					// actBalance = balanceData[0][key]
				// }
				// get expense 
				let actExpense = 0
				for (let expenseLine of expenseData) {
					// console.log(expenseLine[key])
					let thisAmount = parseFloat(expenseLine[key])
					if (Number.isNaN(Number(thisAmount))) {
						thisAmount = 0 
					} 
					actExpense = actExpense + thisAmount //parseFloat(expenseLine[key])
				}

				// get income
				let actIncome = 0
				for (let incomeLine of incomeData) {
					// console.log(incomeLine[key])
					let thisAmount = parseFloat(incomeLine[key])
					if (Number.isNaN(Number(thisAmount))) {
						thisAmount = 0 
					} 
					actIncome = actIncome + thisAmount //parseFloat(incomeLine[key])
				}
				// calculate balance data
				actBalance = actBalance + (actIncome - actExpense)
				let pl = (actIncome - actExpense)
				// update balance table
				
				/*
				for (const [akey, avalue] of Object.entries(expenseData)) {
					console.log('akv',akey,key,avalue)
					// value is expense line
					for(let expenseLine of avalue) {
						console.log('expenseLine',expenseLine)
					}
					
				}
				*/
				let newLine = {
					date: key,
					Income: actIncome,
					Expense: actExpense,
					Balance: actBalance
				}
				newData.push(newLine)
				this.balanceData[0][key] = actBalance
				this.balanceData[1][key] = pl
			}
			// console.log('new', this.balanceData)
			window.balanceTable.replaceData(this.balanceData)
			window.balanceTable.redraw()
			this.chartDataF.rows = []
			this.chartDataF.rows = newData
//window.dispatchEvent(new CustomEvent("hello", {detail: { name: "John" }}));

			
			let links = document.querySelectorAll("[data-parent]")
			// console.log(links[1])		
			links.forEach(function(item) {
				console.log(item.getAttribute('data-parent'))
				let name = item.getAttribute('data-parent')
				// window.dispatchEvent(new CustomEvent("hello", {detail: { name: "John" }}));
				let menuContent = `
					<div id="template">
					<ul class="list-group" style="border:none;">
					<a href="#" onclick="javascript:window.dispatchEvent(new CustomEvent('hello', {detail: { name: '` + name + `', action: 'clear' }}));return false;" class="list-group-item pop" style="border:none;"><i class="tt icon-feather-slash"></i> Clear values</a>
					<a href="#" onclick="javascript:window.dispatchEvent(new CustomEvent('hello', {detail: { name: '` + name + `', action: 'populate' }}));return false;" class="list-group-item pop" style="border:none;"><i class="tt icon-feather-corner-down-right"></i> Populate rest</a>
					<a href="#" onclick="javascript:window.dispatchEvent(new CustomEvent('hello', {detail: { name: '` + name + `', action: 'duplicate' }}));return false;" class="list-group-item pop" style="border:none;"><i class="tt icon-feather-copy" ></i> Duplicate row</a>
					<a href="#" onclick="javascript:window.dispatchEvent(new CustomEvent('hello', {detail: { name: '` + name + `', action: 'delete' }}));return false;" class="list-group-item pop" style="border:none;"><i class="tt icon-feather-trash"></i> Delete</a>
					</ul>
					</div>`
				tippy(item, {
					content: menuContent,
					allowHTML: true,
					theme: 'light',
					interactive: true,
					appendTo: document.body
				});	
			});
//						tippy(document.querySelectorAll('.tt')).hide()

		}
  },
  mounted () {
		// tippy('[data-tippy-content]');

	 // this.act()
	 // balance
	 		let that = this
	 		window.balanceTable = new Tabulator("#balanceTable", {
			columns:[
			{rowHandle:true, formatter:"handle", headerSort:false, frozen:true, width:30, minWidth:30},
			{headerSort:false,title:" ", field:"name", editor:"input",width:200, responsive:0}, //never hide this column
			{title:"Jan", field:"Jan", headerSort:false},
			{title:"Feb", field:"Feb", headerSort:false},
			{title:"Mar", field:"Mar", headerSort:false},
			{title:"Apr", field:"Apr", headerSort:false},
			{title:"May", field:"May", headerSort:false},
			{title:"Jun", field:"Jun", headerSort:false},
			{title:"Jul", field:"Jul", headerSort:false},
			{title:"Aug", field:"Aug", headerSort:false},
			{title:"Sep", field:"Sep", headerSort:false},
			{title:"Oct", field:"Oct", headerSort:false},
			{title:"Nov", field:"Nov", headerSort:false},
			{title:"Dec", field:"Dec", headerSort:false},
			{headerSort:false,formatter:printIconHidden, width:40, align:"center"},
			],
			dataTree:false,
			layout:"fitColumns",
			dataTreeStartExpanded:false,
			movableRows: false,
			selectable:false,
			responsiveLayout:"collapse"
			// keybindings:{
			//		"navRight" : '39',
			//		"navLeft": '37'
			// }
		})
		this.balanceData = [
		{name:"Balance", Jan: 100000, Feb: 200000,Mar: 200000,Apr: 200000,May: 200000,Jun: 200000, Jul: 200000,Aug: 200000,Sep: 200000,Oct: 200000,Nov: 200000,Dec: 200000 },
	]
		window.balanceTable.replaceData(this.balanceData)
	 // expenses
		window.expenseTable = new Tabulator("#expensesTable", {
			columns:[
				{rowHandle:true, formatter:"handle", headerSort:false, frozen:true, width:30, minWidth:30},
			{title:"Expense name", field:"name", editor:"input",width:200, responsive:0}, //never hide this column
			{title:"Jan", field:"Jan",editor:"input", headerSort:false},
			{title:"Feb", field:"Feb",editor:"input", headerSort:false},
			{title:"Mar", field:"Mar",editor:"input", headerSort:false},
			{title:"Apr", field:"Apr",editor:"input", headerSort:false},
			{title:"May", field:"May",editor:"input", headerSort:false},
			{title:"Jun", field:"Jun",editor:"input", headerSort:false},
			{title:"Jul", field:"Jul",editor:"input", headerSort:false},
			{title:"Aug", field:"Aug",editor:"input", headerSort:false},
			{title:"Sep", field:"Sep",editor:"input", headerSort:false},
			{title:"Oct", field:"Oct",editor:"input", headerSort:false},
			{title:"Nov", field:"Nov",editor:"input", headerSort:false},
			{title:"Dec", field:"Dec",editor:"input", headerSort:false},
			{headerSort:false,formatter:printIcon, width:40, align:"center", /* cellClick:function(e, cell){that.deleteRow(cell.getRow().getData().name, 'expenseTable')} */},
			],
			dataTree:false,
			layout:"fitColumns",
			dataTreeStartExpanded:false,
			movableRows: true,
			// keybindings:{
			//		"navRight" : '39',
			//		"navLeft": '37'
			//}
		})
	this.expenseData = [
		{name:"Services", Jan: 100000, Feb: 200000,Mar: 200000,Apr: 200000,May: 200000,Jun: 200000, Jul: 200000,Aug: 200000,Sep: 200000,Oct: 200000,Nov: 200000,Dec: 200000 },
		{name:"Suppliers", Jan: 100000, Feb: 200000,Mar: 200000,Apr: 200000,May: 200000,Jun: 200000, Jul: 200000,Aug: 200000,Sep: 200000,Oct: 200000,Nov: 200000,Dec: 200000 },
    {name:"People", Jan: 100000, Feb: 200000,Mar: 200000,Apr: 200000,May: 200000,Jun: 200000, Jul: 200000,Aug: 200000,Sep: 200000,Oct: 200000,Nov: 200000,Dec: 200000 },
    {name:"Others", Jan: 100000, Feb: 200000,Mar: 200000,Apr: 200000,May: 200000,Jun: 200000, Jul: 200000,Aug: 200000,Sep: 200000,Oct: 200000,Nov: 200000,Dec: 200000 },
	]
	window.expenseTable.replaceData(this.expenseData)

	window.incomeTable = new Tabulator("#incomeTable", {
			columns:[
			{rowHandle:true, formatter:"handle", headerSort:false, frozen:true, width:30, minWidth:30},
			{title:"Income name", field:"name", editor:"input",width:200, responsive:0}, //never hide this column
			{title:"Jan", field:"Jan",editor:"input", headerSort:false},
			{title:"Feb", field:"Feb",editor:"input", headerSort:false},
			{title:"Mar", field:"Mar",editor:"input", headerSort:false},
			{title:"Apr", field:"Apr",editor:"input", headerSort:false},
			{title:"May", field:"May",editor:"input", headerSort:false},
			{title:"Jun", field:"Jun",editor:"input", headerSort:false},
			{title:"Jul", field:"Jul",editor:"input", headerSort:false},
			{title:"Aug", field:"Aug",editor:"input", headerSort:false},
			{title:"Sep", field:"Sep",editor:"input", headerSort:false},
			{title:"Oct", field:"Oct",editor:"input", headerSort:false},
			{title:"Nov", field:"Nov",editor:"input", headerSort:false},
			{title:"Dec", field:"Dec",editor:"input", headerSort:false},
			{headerSort:false,formatter:printIcon, width:40, align:"center", /* cellClick:function(e, cell){that.deleteRow(cell.getRow().getData().name, 'incomeTable')} */},
			],
			dataTree:false,
			layout:"fitColumns",
			dataTreeStartExpanded:false,
			movableRows: true,
			keybindings:{
					"navRight" : '39',
					"navLeft": '37'
			}
		})
		this.incomeData = [
    {name:"Bookings", Jan: '', Feb: '',Mar: '',Apr: '',May: '',Jun: '', Jul: '',Aug: '',Sep: '',Oct: '',Nov: '',Dec: '' },
    {name:"Tours", Jan: 100000, Feb: 200000,Mar: 200000,Apr: 200000,May: 200000,Jun: 200000, Jul: 200000,Aug: 200000,Sep: 200000,Oct: 200000,Nov: 200000,Dec: 200000 },
		{name:"Restaurant", Jan: 100000, Feb: 200000,Mar: 200000,Apr: 200000,May: 200000,Jun: 200000, Jul: 200000,Aug: 200000,Sep: 200000,Oct: 200000,Nov: 200000,Dec: 200000 },
		{name:"Other", Jan: 100000, Feb: 200000,Mar: 200000,Apr: 200000,May: 200000,Jun: 200000, Jul: 200000,Aug: 200000,Sep: 200000,Oct: 200000,Nov: 200000,Dec: 200000 },
		]

	window.incomeTable.replaceData(this.incomeData)
	this.refresh()

	// listen for event
	// let that = this
	window.addEventListener("hello", function(event) {
		// alert(event.detail.name);
		// hide all tipy
		console.log('event',event)
		// document.querySelectorAll('.btn')
		let message = event.detail
		// find table where name exists
		const incomeTable = JSON.parse(JSON.stringify(that.incomeData))
		let isIncomeTable = false
		for (let item of incomeTable) {
			// console.log(item.name)
			if (item.name === message.name) {
				isIncomeTable = true
			}
		}
		const expenseTable = JSON.parse(JSON.stringify(that.expenseData))
		let isExpenseTable = false
		for (let item of expenseTable) {
			// console.log(item.name)
			if (item.name === message.name) {
				isExpenseTable = true
			}
		}
		if(isExpenseTable) {
			if(message.action === 'delete') {
				that.deleteRow(message.name, 'expenseTable')
			}
			if(message.action === 'clear') {
				that.clearRow(message.name, 'expenseTable')
			}
			if(message.action === 'populate') {
				that.populateRow(message.name, 'expenseTable')
			}
			if(message.action === 'duplicate') {
				that.duplicateRow(message.name, 'expenseTable')
			}
		}
		if(isIncomeTable) {
			if(message.action === 'delete') {
				that.deleteRow(message.name, 'incomeTable')
			}
			if(message.action === 'clear') {
				that.clearRow(message.name, 'incomeTable')
			}
			if(message.action === 'populate') {
				that.populateRow(message.name, 'incomeTable')
			}
			if(message.action === 'duplicate') {
				that.duplicateRow(message.name, 'incomeTable')
			}
		}
		console.log('is',isIncomeTable,isExpenseTable)
		// that.deleteRow(message.name, 'incomeTable')
		console.log(message)
	})

 }
}
</script>
<style>
.ql-container {
    font-size: 1rem;
}
.ql-editor{
    min-height:200px;
}
.panel-fullscreen {
    display: block;
    z-index: 9999;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    overflow: auto;
}

.btncon {
    display: inline-block;
    position: relative;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border: none;
    outline: none;
    background-color: transparent;
    fill: currentColor;
    color: inherit;
  /*  font-size: 24px; */
    text-decoration: none;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
 /*   width: 48px;
    height: 48px;
    padding: 12px; */
}
.btncon:hover {
	color:#2347cc;	
}


 .tabulator-selectable {
/*
border-left-width: 2px !important;
 border-color: white;
 color: #656565;
   border-left-style: solid;
	    border-top: none;
		border-bottom: none;
		*/
    cursor: pointer;

}

 .tabulator-row.tabulator-selectable:hover {
    /* background-color: red !important; */
		background-color: #fffae6 !important;

		border-radius: 12px;
		color: black;
    cursor: pointer;
}

 .tabulator-row .tabulator-selectable:hover {
    background-color: #a94442;
    cursor: pointer;
}


 .tabulator-row.tabulator-selectable:hover {
    background-color: #bbb;
    cursor: pointer;
 }

/*
 .tabulator-selectable:hover {
  border-color: #22BAA0;
	color: black;
	border: 1px solid #22BAA0;
	border-left: none;
	border-right: none;
    border-left-width: 2px !important;
    border-left-style: solid;
    border-top: none;
		border-bottom: none;
    cursor: pointer;
}
*/
.tabulator-header {
font-family: "proxima_nova_ltsemibold","HelveticaNeue", "Helvetica Neue", Helvetica, Arial,sans-serif;
    /* border-bottom: none; */
		border: none;
		/* border-bottom: 2px solid #dee2e6; */
		color: #656565;
    line-height: 1.5;
		font-size: 10px;
    text-transform: uppercase;
}

.tabulator-footer {
	text-align: center !important;
}

/* colors in modal */
.cblack {
	color: black;
}


.cgray {
	color: #333;
	/* #c9c9c9 */
}

a.pop:hover{
color: #0056b3 !important;
    background-color: #e9ecef !important;
    text-decoration: none !important;
}
a.pop{
color: #6f42c1 !important;
    text-decoration: none !important;
}


/* #e9ecef; FFF7EA*/
.notie-input-field {
    background-color: #FFF7EA;
}

.notie-textbox {
    color: #000;
}
.notie-background-info {
    background-color: #e9ecef;
}
</style>
